import Model from "~/models/_Model";
import dayjs from "dayjs";

export default class Notification extends Model {
  // Define a base url for a REST API
  baseURL() {
    return super.baseURL() + "/leydenmobile";
  }

  // Set the resource route of the model
  resource() {
    return "notifications";
  }

  primaryKey() {
    return "PAM_ID";
  }

  relations() {
    return {
      //student: Student,
    };
  }

  /**
   * Helper Methods
   */

  /**
   * Helper Attributes
   */
  get display_datetime() {
    return dayjs(this.PAM_TStamp).format("MM/DD/YYYY h:mm A");
  }
}
